/* Copyright Levelise Ltd 2025 */
import { createContext, useState } from 'react';

const defaultValues = {
	selectedFacility: null,
	setSelectedFacility: () => {},
};

const CustomerContext = createContext(defaultValues);

export const CustomerProvider = ({ children }) => {
	const [selectedFacility, setSelectedFacility] = useState(null);

	return (
		<CustomerContext.Provider
			value={{
				selectedFacility,
				setSelectedFacility,
			}}
		>
			{children}
		</CustomerContext.Provider>
	);
};

export default CustomerContext;
